/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-09-13 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  addWidgetNow: () => void,
  doItLater: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class EnhancePlacementWarningModal extends Component<ComposedProps> {
  render() {
    const { active, i18n, addWidgetNow, doItLater } = this.props;
    return (
      <Modal
        open={active}
        onClose={addWidgetNow}
        title={i18n.translate(
          'AdminHTML.Recommendation.WidgetItem.placement_Enhance_Placement_Modal_Title'
        )}
        primaryAction={{
          content: i18n.translate(
            'AdminHTML.Recommendation.WidgetItem.placement_Enhance_Placement_Modal_Btn_Add_Widget_Now'
          ),
          onAction: addWidgetNow
        }}
        secondaryActions={[
          {
            content: i18n.translate(
              'AdminHTML.Recommendation.WidgetItem.placement_Enhance_Placement_Modal_Btn_Do_It_Later'
            ),
            onAction: doItLater
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate(
                'AdminHTML.Recommendation.WidgetItem.placement_Enhance_Placement_Modal_Content'
              )}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(EnhancePlacementWarningModal);
